import { Injectable } from '@angular/core';
import { ContactModel } from '../models/contact.model';

@Injectable({ providedIn: 'root' })
export class ManagementHelperService {

  getAlphabetWithSpecial(): string[] {
    const alphabet = [...Array(26)].map((_, i) => String.fromCharCode(65 + i));
    alphabet.push('#', '?');
    return alphabet;
  }

  groupByInitial<T>(items: T[], field: keyof T): Record<string, T[]> {
    const grouped: Record<string, T[]> = {};

    for (const item of items) {
      const raw = (item[field] as string)?.trim() ?? '';
      let firstLetter = raw.charAt(0).toUpperCase() || '#';
      if (!/^[A-Z]$/.test(firstLetter) && firstLetter !== '#') {
        firstLetter = '?';
      }
      if (!grouped[firstLetter]) {
        grouped[firstLetter] = [];
      }
      grouped[firstLetter].push(item);
    }

    return grouped;
  }

  scrollToElementById(id: string, block: ScrollLogicalPosition = 'center', behavior: ScrollBehavior = 'smooth') {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior, block });
    }
  }

  highlightTemporarily(id: string, duration: number = 2000) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add('highlight');
      setTimeout(() => el.classList.remove('highlight'), duration);
    }
  }

checkContactExisit(contact: ContactModel): boolean {
  if (!contact) return false;

  const isNonEmpty = (value: any): boolean => typeof value === 'string' && value.trim().length > 0;

  return (
    isNonEmpty(contact.companyName) ||
    isNonEmpty(contact.firstName) ||
    isNonEmpty(contact.lastName)
  );
}

  checkHasValues(contact: ContactModel): boolean {
    if (!contact) return false;

    const keys = Object.keys(contact).filter(k => k !== 'id') as (keyof ContactModel)[];

    return keys.some(key => {
      const value = contact[key];
      if (value === null || value === undefined) return false;
      if (typeof value === 'string') return value.trim().length > 0;
      if (Array.isArray(value)) return value.length > 0;
      return true;
    });
  }
}
